type Props = {
  dark?: boolean;
};

export const ThreeDotLoader = ({ dark }: Props) => {
  return (
    <div className="w-full h-14rem flex justify-content-center align-items-center">
      <span className={`square-loader${dark ? '-dark' : ''}`}></span>
    </div>
  );
};
